module.exports = __webpack_public_path__ + "img/RIGID TANKER_RHD.04834104.jpg";